import type { ElementType, ReactNode } from 'react';

import { cn } from '../lib/cn';

export interface EmptyStateProps {
  title: ReactNode;
  description?: ReactNode;
  /** Ícone decorativo (ex.: lucide). Fica `aria-hidden`. */
  icon?: ReactNode;
  /** Ação principal (ex.: `<Button>`). */
  action?: ReactNode;
  headingLevel?: 'h2' | 'h3' | 'h4';
  className?: string;
}

/**
 * Estado vazio honesto (REGRA 01 do AGENTS.md): diz que não há dados e o próximo passo; nunca preenche com exemplos.
 */
export function EmptyState({
  title,
  description,
  icon,
  action,
  headingLevel = 'h3',
  className,
}: EmptyStateProps) {
  const Heading: ElementType = headingLevel;
  return (
    <div
      data-slot="empty-state"
      className={cn(
        'flex flex-col items-center gap-3 rounded-card border border-dashed border-border-strong bg-surface-sunken px-6 py-10 text-center',
        className,
      )}
    >
      {icon ? (
        <div
          data-slot="empty-state-icon"
          aria-hidden="true"
          className="flex size-12 items-center justify-center rounded-pill bg-surface text-muted-foreground [&>svg]:size-6"
        >
          {icon}
        </div>
      ) : null}
      <Heading className="text-title font-semibold text-heading">{title}</Heading>
      {description ? (
        <p className="max-w-prose text-body text-muted-foreground">{description}</p>
      ) : null}
      {action ? <div className="mt-1">{action}</div> : null}
    </div>
  );
}
